import { reactive } from 'vue'
import moment from 'moment'

/*
 * The date the calendar is showing.
 *
 * Was an Angular factory (step 33 of #614). It takes no dependencies at all, and every reader is
 * Vue except `bookingService` - so the state is `Vue.observable`, and the two components that react
 * to it use an ordinary Vue watcher. They previously went through `services.watch`, which is
 * `$rootScope.$watch` and needed an Angular digest to notice a change.
 */
const state = reactive({ selectedDate: moment().toDate() })

const calendarService = {
  state,

  getSelectedDate: () => state.selectedDate,

  setSelectedDate: newDate => {
    state.selectedDate = newDate
  },
}

export default calendarService
